import graphql__7cc8879cc356fb8a1ed0 from "./__generated__/ContributionsDatavizThemeLayout_theme.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { getContributionsAnchorId } from "../../../Utils/anchorIds";
import ContributionsDatavizTabs from "./ContributionsDatavizTabs";
import ContributionsDatavizThemeViewSidebar from "./ContributionsDatavizThemeViewSidebar";

const ContributionsDatavizThemeLayout = props => {
  const theme = useFragment(ContributionsDatavizThemeLayout_theme, props.theme);

  const { participativeModule } = theme;
  const {
    children,
    graphViewActive,
    listViewActive,
    filtersRefetchFragment,
    filtersRefetchFragmentParent,
    pagesCount
  } = props;

  const className = classNames("participative-datavisualization-container", "container", {
    "participative-datavisualization-graph-theme": graphViewActive,
    "participative-datavisualization-list-theme": listViewActive
  });
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <div id={contributionsAnchorId} className={className}>
      <ContributionsDatavizTabs
        participativeModule={participativeModule}
        exploreTabActive={true}
      />

      <div className="row">
        <div className="col-md-4 datavizItem">
          <ContributionsDatavizThemeViewSidebar
            theme={theme}
            graphViewActive={graphViewActive}
            listViewActive={listViewActive}
            filtersRefetchFragment={filtersRefetchFragment}
            filtersRefetchFragmentParent={filtersRefetchFragmentParent}
            pagesCount={pagesCount}
          />
        </div>

        <div className="col-md-8">{children}</div>
      </div>
    </div>
  );
};

const ContributionsDatavizThemeLayout_theme = graphql__7cc8879cc356fb8a1ed0;

export default ContributionsDatavizThemeLayout;
